import ReactDOM from 'react-dom/client';
import { v2Component } from '../../../index';
import { OrderView } from './order-view';
import { ToastContainer } from 'react-toastify';
import { AdminContextProvider } from '../../../context/admin-context';
import { parseInt } from 'lodash';

export function initOrderView() {
  document.getElementsByName('order-page').forEach((element) => {
    if (element.getAttribute('initialized') !== 'true') {
      element.setAttribute('initialized', 'true');
      const root = ReactDOM.createRoot(element);

      const bootstrap = () => {
        const { orderId } = Object.assign({}, element.dataset) as any;
        root.render(
          v2Component(
            <AdminContextProvider>
              <ToastContainer />
              <OrderView orderId={parseInt(orderId)} />
            </AdminContextProvider>,
          ),
        );
      };

      bootstrap();
    }
  });
}
